import { SERVICE_ROUTE_NAME } from '@/libs/route-name';

export const servicesRoute = () => {
    return {
        name: SERVICE_ROUTE_NAME.LIST_SERVICE,
        path: 'services',
        component: () => import('@/pages/services/index.vue'),
    };
};

